import { makeStyles } from "@material-ui/core/styles";

export const increasePriceStyle = makeStyles(() => ({
  formWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    padding: '20px',
    maxWidth: '600px',
    margin: '0 auto'
  },
  colorBlue: {
    color: '#1976d2',
    marginBottom: '10px'
  },
  width100: {
    width: '100%',
    marginBottom: '20px'
  },
  currentPrice: {
    fontSize: '16px',
    fontWeight: 500,
    marginTop: '10px',
    color: '#666'
  }
}));
